import {
  createPayinsConfiguration as publicCreatePayinsConfiguration,
  getPayinsConfiguration as publicGetPayinsConfiguration,
  updatePayinsConfiguration as publicUpdatePayinsConfiguration,
  queryPayinsConfigurations as publicQueryPayinsConfigurations,
  typedQueryPayinsConfigurations as publicTypedQueryPayinsConfigurations,
  bulkUpdatePayinsConfigurationTags as publicBulkUpdatePayinsConfigurationTags,
  bulkUpdatePayinsConfigurationTagsByFilter as publicBulkUpdatePayinsConfigurationTagsByFilter,
} from './payments-payins-configurations-v1-payins-configuration-payins-configurations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PayinsConfigurationQuery,
  PayinsConfigurationsQueryBuilder,
  typedQueryPayinsConfigurations as universalTypedQueryPayinsConfigurations,
} from './payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';

function customQueryPayinsConfigurations(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryPayinsConfigurations(httpClient)(),
    typedQueryFunction: (query: PayinsConfigurationQuery) =>
      publicTypedQueryPayinsConfigurations(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): PayinsConfigurationsQueryBuilder;
  function overloadedQuery(
    query: PayinsConfigurationQuery
  ): ReturnType<typeof universalTypedQueryPayinsConfigurations>;
  function overloadedQuery(query?: PayinsConfigurationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

/** @internal */
export const createPayinsConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicCreatePayinsConfiguration> &
    typeof publicCreatePayinsConfiguration
> = /*#__PURE__*/ createRESTModule(publicCreatePayinsConfiguration);
/** @internal */
export const getPayinsConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicGetPayinsConfiguration> &
    typeof publicGetPayinsConfiguration
> = /*#__PURE__*/ createRESTModule(publicGetPayinsConfiguration);
/** @internal */
export const updatePayinsConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePayinsConfiguration> &
    typeof publicUpdatePayinsConfiguration
> = /*#__PURE__*/ createRESTModule(publicUpdatePayinsConfiguration);
/** @internal */
export const bulkUpdatePayinsConfigurationTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePayinsConfigurationTags> &
    typeof publicBulkUpdatePayinsConfigurationTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdatePayinsConfigurationTags);
/** @internal */
export const bulkUpdatePayinsConfigurationTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePayinsConfigurationTagsByFilter> &
    typeof publicBulkUpdatePayinsConfigurationTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdatePayinsConfigurationTagsByFilter
);
export const queryPayinsConfigurations: MaybeContext<
  BuildRESTFunction<typeof customQueryPayinsConfigurations> &
    typeof customQueryPayinsConfigurations
> = /*#__PURE__*/ createRESTModule(customQueryPayinsConfigurations);

export {
  SortOrder,
  WebhookIdentityType,
} from './payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';
export {
  PayinsConfiguration,
  PayinsRule,
  MerchantSelection,
  ExtendedFields,
  Tags,
  TagList,
  CreatePayinsConfigurationRequest,
  CreatePayinsConfigurationResponse,
  GetPayinsConfigurationRequest,
  GetPayinsConfigurationResponse,
  UpdatePayinsConfigurationRequest,
  UpdatePayinsConfigurationResponse,
  QueryPayinsConfigurationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryPayinsConfigurationsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkUpdatePayinsConfigurationTagsRequest,
  BulkUpdatePayinsConfigurationTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdatePayinsConfigurationTagsResult,
  BulkActionMetadata,
  BulkUpdatePayinsConfigurationTagsByFilterRequest,
  BulkUpdatePayinsConfigurationTagsByFilterResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  UpdatePayinsConfiguration,
  PayinsConfigurationsQueryResult,
  PayinsConfigurationsQueryBuilder,
  PayinsConfigurationQuerySpec,
  BulkUpdatePayinsConfigurationTagsOptions,
  BulkUpdatePayinsConfigurationTagsByFilterOptions,
} from './payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';
export { utils } from './payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  PayinsConfigurationQuery,
} from './payments-payins-configurations-v1-payins-configuration-payins-configurations.universal.js';
